(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
// NOT (ASCII KURALI, 2026-09-11): bu javascript bloguna ASCII DISI KARAKTER EKLEME.
// COK-BAYTLI karakterler (Turkce harf, ok isareti) Shopify'in derledigi
// compiled_assets/scripts.js dosyasinin SONUNDAN o kadar bayt YIYOR (karakter/bayt
// sayim hatasi) -> dosya kesiliyor, hicbir custom element tanimlanamiyordu.
// Kullaniciya gorunen metinler Liquid tarafinda data-attribute ile verilir.
// (Ayrica yorum icine Liquid etiketi YAZMA - theme check ve extractor sasiriyor.)

// Sepet onerisi slider'i icin 6 sn'de bir otomatik gecis (mobil sepet slider'i
// gibi). scroll-carousel'in kendi elle-kaydirmasi korunur; kullanici dokununca
// duraklar, birakinca sayac sifirlanir. <scroll-carousel> sarmalanir; custom
// element connectedCallback re-render'larda (sepet guncellenince) yeniden kurar.
class AutoplayScrollCarousel extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('scroll-carousel');
    if (!this.carousel) return;
    // Istemci guvencesi: ayni urunden (handle) birden fazla kart varsa fazlasini kaldir
    // (sunucu dedup'ina EK - ilk-ekleme gecis ani gibi nadir durumlarda iki kart olusmasin).
    // Kaldirilan kart kadar fazla nokta gostergesini de temizle ki sayim tutsun.
    const seenHandles = new Set();
    let removedCount = 0;
    this.carousel.querySelectorAll('product-card[handle]').forEach((card) => {
      const handle = card.getAttribute('handle');
      if (!handle) return;
      if (seenHandles.has(handle)) {
        card.remove();
        removedCount += 1;
      } else {
        seenHandles.add(handle);
      }
    });
    if (removedCount > 0 && this.parentElement) {
      const nav = this.parentElement.querySelector('carousel-navigation');
      if (nav) {
        const dots = nav.querySelectorAll('button');
        for (let i = 0; i < removedCount && dots.length - 1 - i >= 0; i++) {
          dots[dots.length - 1 - i].remove();
        }
      }
    }
    this.intervalMs = parseInt(this.getAttribute('interval'), 10) || 6000;
    this._advance = this._advance.bind(this);
    this._pause = () => this._stop();
    this._resume = () => this._start();
    this.carousel.addEventListener('pointerdown', this._pause);
    window.addEventListener('pointerup', this._resume);
    this._start();
  }

  disconnectedCallback() {
    this._stop();
    window.removeEventListener('pointerup', this._resume);
  }

  _start() {
    this._stop();
    const c = this.carousel;
    // Tek kart / tasmiyorsa otomatik gecis yok.
    if (c && c.scrollWidth > c.clientWidth + 4) {
      this.timer = setInterval(this._advance, this.intervalMs);
    }
  }

  _stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  _advance() {
    const c = this.carousel;
    // Sekme/cekmece gizliyse atla.
    if (document.hidden || !c.clientWidth) return;
    // Bir sonraki kartin basina kaydir (kartlar arasi gap'e ragmen tam hizali);
    // sondaysa basa don. offsetLeft, position:relative scroll-carousel'e goredir.
    const cells = Array.from(c.children);
    if (cells.length < 2) return;
    const next = cells.find((el) => el.offsetLeft > c.scrollLeft + 8);
    c.scrollTo({ left: next ? next.offsetLeft : 0, behavior: 'smooth' });
  }
}

if (!customElements.get('autoplay-scroll-carousel')) {
  customElements.define('autoplay-scroll-carousel', AutoplayScrollCarousel);
}

// Yatay urun kartinda (tamamlayici + sepet slider'lari) kart-ici swatch secimini
// "Sepete ekle" formuna baglar: secili swatch'in data-variant-id'sini gizli `id`
// input'una yazar -> quick-buy modali acilmadan secili varyant eklenir. Swatch
// radio'lari <product-card>'da; degisiklik kartta delege dinlenir.
class CardAddForm extends HTMLElement {
  connectedCallback() {
    this.idInput = this.querySelector('input[name="id"]');
    if (!this.idInput) return;
    this.card = this.closest('product-card');
    if (!this.card) return;
    // Ilk durumu secili (checked) swatch'a gore senkronla.
    const checked = this.card.querySelector('.product-card__info [type="radio"][data-variant-id]:checked');
    if (checked) this.idInput.value = checked.getAttribute('data-variant-id');
    this._onChange = (event) => {
      const radio = event.target;
      if (radio && radio.matches && radio.matches('[type="radio"][data-variant-id]')) {
        this.idInput.value = radio.getAttribute('data-variant-id');
      }
    };
    this.card.addEventListener('change', this._onChange);
    // KRITIK: "Sepete ekle" scroll-carousel ICINDE. Carousel surukle handler'i
    // mousedown'da bir click-suppress dinleyicisi kurup en ufak harekette bile
    // click'in DEFAULT submit'ini prevent ediyor -> buton sepete eklemiyordu.
    // Buton alanindaki mousedown'u carousel'e ULASTIRMA -> carousel drag kurmaz ->
    // native form submit normal calisir. (Swatch'lar bu sarmalin DISINDA, etkilenmez.)
    this._stopDrag = (event) => event.stopPropagation();
    this.addEventListener('mousedown', this._stopDrag);
  }

  disconnectedCallback() {
    if (this.card && this._onChange) {
      this.card.removeEventListener('change', this._onChange);
    }
  }
}

if (!customElements.get('card-add-form')) {
  customElements.define('card-add-form', CardAddForm);
}

// Birlestirilmis sepet satiri (kremi-line-group-quantity.liquid'in JS'i).
// "3 Al 2 Ode" ayni varyanti boler ve HER sepet degisiminde satir anahtarlarini
// yeniden yazar -> render aninda yakalanan anahtar bir sonraki islemde BAYAT olur;
// bayat anahtarla update.js "kilitli" gibi hissettiren hataya dusuyordu (kullanici
// bulgusu 2026-09-11). Cozum: anahtarlari render'dan DEGIL, tiklama aninda CANLI
// /cart.js'den turet - kampanyanin anahtar degistirmesine tumuyle bagisik. Stabil
// olan tek sey varyant kimligi (data-variant-id); anahtarlar volatildir.
//
// Mutasyon: varyantin o anki TUM ozelliksiz satirlari tek update.js isteginde -
// ilk anahtar yeni TOPLAMI alir, kalanlar 0. Varyant-id ile update KULLANMA:
// bolunmus satirlarda toplami sisiriyor (olculdu). Yeniden cizim `cart:refresh`
// ile: temanin ekleme-sonrasi kullandigi yol - sayac, nokta ve cekmeceyi birlikte
// sunucudan tazeler, elle bolum paketlemeye gerek yok. /cart sayfasinda reload.
class KremiLineGroup extends HTMLElement {
  connectedCallback() {
    this._onClick = (event) => {
      const btn = event.target.closest('[data-kremi-lg]');
      if (!btn || btn.disabled || btn.getAttribute('data-kremi-lg') === 'input') return;
      const mode = btn.getAttribute('data-kremi-lg');
      // +/- DELTA tasir, mutlak sayi degil: ekrandaki sayi da bayatlayabilir
      // (canli toplam sunucudan okunur, delta ona uygulanir).
      if (mode === 'minus') this._apply({ delta: -1 });
      else if (mode === 'plus') this._apply({ delta: 1 });
      else if (mode === 'remove') this._apply({ absolute: 0 });
    };
    this._onChange = (event) => {
      const input = event.target.closest('input[data-kremi-lg="input"]');
      if (!input) return;
      const value = parseInt(input.value, 10);
      if (Number.isNaN(value)) return;
      this._apply({ absolute: value });
    };
    this.addEventListener('click', this._onClick);
    this.addEventListener('change', this._onChange);
  }

  _lock(locked) {
    // Ucus sirasinda kontroller gercekten devre disi: cift tik / yaris engeli.
    this.querySelectorAll('button[data-kremi-lg], input[data-kremi-lg]').forEach((el) => {
      el.disabled = locked;
    });
  }

  _error(message) {
    this.parentElement && this.parentElement.querySelector('[role="alert"]')?.remove();
    this.insertAdjacentHTML('afterend', `<p class="text-xs text-subdued" role="alert">${message}</p>`);
  }

  async _apply(change) {
    if (this._busy) return;
    this._busy = true;
    this._lock(true);
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      // HEM anahtarlar HEM mevcut toplam CANLI sepetten: DOM'daki hicbir degere
      // guvenilmez (kampanya her islemde anahtarlari yeniden yazar; ekran bir
      // islem geride kalmis olabilir). data-keys yalniz cart.js duserse yedek.
      let keys = [];
      let liveTotal = parseInt(this.getAttribute('data-quantity'), 10) || 0;
      try {
        const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        const lines = cart.items.filter(
          (it) => String(it.variant_id) === String(variantId) && (!it.properties || Object.keys(it.properties).length === 0)
        );
        keys = lines.map((it) => it.key);
        liveTotal = lines.reduce((sum, it) => sum + it.quantity, 0);
      } catch (e) { /* yedege dus */ }
      if (!keys.length) {
        keys = (this.getAttribute('data-keys') || '').split(',').filter(Boolean);
      }
      if (!keys.length) {
        // Satir sunucuda zaten yok (baska sekme/islem silmis): ekrani tazele, yeter.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      const max = parseInt(this.getAttribute('data-max'), 10);
      let total = change.absolute != null ? change.absolute : liveTotal + change.delta;
      total = Math.max(0, total);
      if (!Number.isNaN(max) && max >= 0) total = Math.min(total, max);

      const updates = {};
      keys.forEach((key) => { updates[key] = 0; });
      updates[keys[0]] = total;

      // Stok akisin birebir aynisi: cekmece bolumu istege ilistirilir, yanit taze
      // HTML tasir -> cart:change ile SENKRON yeniden cizim (ikinci fetch/yaris yok).
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates, sections: sectionsToBundle.join(',') }),
      });
      if (!response.ok) {
        const content = await response.json().catch(() => ({}));
        this._error(content.description || content.message || this.getAttribute('data-msg-fail') || 'G\u00fcncellenemedi.');
        // Ekran ile sunucu ayrismis olabilir: taze render iste ki sonraki tik dogru olsun.
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }
      const cartContent = await response.json();

      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        window.location.reload();
        return;
      }
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'line-item:change', cart: cartContent },
      }));
    } catch (error) {
      this._error(this.getAttribute('data-msg-network') || 'Ba\u011flant\u0131 hatas\u0131. L\u00fctfen tekrar deneyin.');
    } finally {
      this._busy = false;
      this._lock(false);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }
}

if (!customElements.get('kremi-line-group')) {
  customElements.define('kremi-line-group', KremiLineGroup);
}

// "Siparis detaylari" acilir kutusunun ac/kapa durumu.
// MASAUSTU (kullanici 09-11): ilk acilista ACIK, kapatilirsa kapali DURUR — tercih
//   localStorage'da (cihazda kalici).
// MOBIL (Zeynep 10-10): cekmecenin HER ACILISINDA KAPALI baslar; acik birakilan detaylar
//   kisa ekranda alt cubugu %65'e cikarip urun satirlarini gizliyordu (uzanti testi).
//   Durum yalniz bellekte tutulur: ayni acilis icinde sepet degisip cekmece yeniden
//   cizilse de (indirim kodu, adet) musterinin actigi detaylar acik kalir; cekmece
//   yeniden ACILINCA ('dialog:before-show') sifirlanir. Mobil durum localStorage'a yazilmaz.
// Sunucu her render'da `open` basar; dogru durum connectedCallback'te uygulanir (cekmece her
// sepet degisiminde yeniden cizildigi icin sarmalayici custom element sart). localStorage
// erisimi her zaman try/catch'te (gizli pencere/engelli tarayicida sayfa yine calisir).
let kremiDetailsMobileOpen = false;
const kremiIsMobile = () => window.matchMedia('(max-width: 699px)').matches;

document.addEventListener('dialog:before-show', (event) => {
  if (!(event.target instanceof Element) || event.target.tagName !== 'CART-DRAWER') return;
  kremiDetailsMobileOpen = false;
  if (!kremiIsMobile()) return;
  event.target.querySelectorAll('kremi-persist-details').forEach((el) => el.applyState?.());
}, true);

class KremiPersistDetails extends HTMLElement {
  connectedCallback() {
    this._details = this.querySelector('details');
    if (!this._details) return;
    this.applyState();
    this._details.addEventListener('toggle', () => {
      // Kendi degisikligimizin tetikledigi (asenkron) toggle tercih sayilmaz.
      if (this._ignoreToggle) { this._ignoreToggle = false; return; }
      if (kremiIsMobile()) {
        kremiDetailsMobileOpen = this._details.open;
        return;
      }
      const key = this.getAttribute('data-storage-key') || 'kremi:details';
      try { localStorage.setItem(key, this._details.open ? 'open' : 'closed'); } catch (e) { /* yazilamadi: sorun degil */ }
    });
  }

  applyState() {
    const details = this._details;
    if (!details) return;
    let wantOpen = true;
    if (kremiIsMobile()) {
      wantOpen = kremiDetailsMobileOpen;
    } else {
      const key = this.getAttribute('data-storage-key') || 'kremi:details';
      try { wantOpen = localStorage.getItem(key) !== 'closed'; } catch (e) { /* okunamadi: acik kalir */ }
    }
    if (details.open !== wantOpen) {
      this._ignoreToggle = true;
      details.open = wantOpen;
    }
  }
}

// Öneri bloğu (.kremi-cart-suggest) çekmece gövdesinde çoğunlukla görünmüyorsa ve
// AŞAĞIDAYSA kaydırma düğmesini gösterir. Gövde gölge DOM'daki part="body" (kaydırılan
// kutu); IntersectionObserver kökü odur. Çekmece her sepet değişiminde yeniden çizilir →
// connected/disconnected her seferinde gözlemciyi kurar/söker.
class KremiCartScrollHint extends HTMLElement {
  connectedCallback() {
    const drawer = this.closest('cart-drawer');
    const body = drawer?.getShadowPartByName?.('body');
    const target = drawer?.querySelector('.cart-drawer__full > .kremi-cart-suggest');
    const heading = target?.querySelector('.h6');
    if (!body || !target || !heading || !('IntersectionObserver' in window)) return;
    this.querySelector('.kremi-cart-scroll-hint__label').textContent = heading.textContent.trim();
    // Kaydırma gövdenin KENDİSİNDE yapılır: gölge DOM'daki iç kaydırma kutusunda
    // scrollIntoView({smooth}) ~30px'te duruyordu (10-10 testi). Şerit önce gizlenir
    // (alt çubuk kısalır → hedef konum değişmesin), konum sonra ölçülür; kayma
    // sürerken gözlemci şeridi yeniden açamaz (_lockUntil).
    this.querySelector('button').addEventListener('click', () => {
      this.hidden = true;
      this._lockUntil = Date.now() + 1200;
      requestAnimationFrame(() => {
        const top = body.scrollTop + target.getBoundingClientRect().top - body.getBoundingClientRect().top;
        body.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
    this._observer = new IntersectionObserver(([entry]) => {
      if (this._lockUntil && Date.now() < this._lockUntil) return;
      const below = entry.boundingClientRect.top > entry.rootBounds.top;
      this.hidden = !(below && entry.intersectionRatio < 0.35);
    }, { root: body, threshold: [0, 0.1, 0.2, 0.35, 0.5] });
    this._observer.observe(target);
  }

  disconnectedCallback() {
    this._observer?.disconnect();
  }
}

// İndirim kodu alanında Enter: tarayıcı formu "örtük gönderir" ve formdaki İLK gönder
// düğmesine (sipariş notu düğmesi) basılmış sayar → not penceresi açılıyordu (10-10
// testi). Enter'ın gönderimi engellenir; alan bırakılınca (blur) tarayıcının kendi
// 'change' olayı bir kez çıkar ve tema kodu uygular (cart-discount-field 'change').
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || event.isComposing) return;
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.closest('cart-discount-field')) return;
  event.preventDefault();
  input.blur();
});

if (!customElements.get('kremi-cart-scroll-hint')) {
  customElements.define('kremi-cart-scroll-hint', KremiCartScrollHint);
}

if (!customElements.get('kremi-persist-details')) {
  customElements.define('kremi-persist-details', KremiPersistDetails);
}


  } catch(e) { console.error(e); }
})();
})();
